import type { ErrorEvent as SentryErrorEvent } from '@sentry/core';

/**
 * Feature-detects browsers below our browserslist floor (Safari/iOS >= 16,
 * recent evergreens). Object.hasOwn (Chrome 93+, Safari 15.4+, Firefox 92+)
 * and Array.prototype.at (Chrome 92+, Safari 15.4+, Firefox 90+) are missing
 * only in browsers we do not support - e.g. old kiosk webviews that crash
 * inside Angular itself.
 */
export const isUnsupportedBrowser = (): boolean =>
  typeof Object.hasOwn !== 'function' || typeof Array.prototype.at !== 'function';

/**
 * Allow to filter issues in Sentry that will not be fixed
 * example https://sentry.cluster.placewise.cc/organizations/sentry/issues/529570/events/93d751a8fdf54594a6d95d47209debe7/
 */
export const tagUnsupportedBrowserEvent = (
  event: SentryErrorEvent,
  unsupported: boolean = isUnsupportedBrowser(),
): SentryErrorEvent => {
  if (unsupported) {
    event.tags = { ...event.tags, unsupported_browser: 'true' };
  }
  return event;
};
